import {AppJSThemeOptions} from '@app/theme';
import {JS_THEME_BASE_VARIABLES} from './js-theme-base';

export const DEFAULT_THEME = {
	name: 'default',
	base: 'default',
	variables: {
		...JS_THEME_BASE_VARIABLES,
		layoutBg: JS_THEME_BASE_VARIABLES.bg,
	},
} as AppJSThemeOptions;
